<form class="" #form="ngForm">
    <ng-container *ngIf="record && record.trainingProgram">
        <mat-form-field>
            <mat-label class="form-label">{{ 'forms.training.completionDate' | appTranslate }}</mat-label>
            <input
                #completedAt="ngModel"
                placeholder="YYYY-MM-DD"
                required
                class="form-input"
                matInput
                name="completedAt"
                [(ngModel)]="record.completedAt"
                [matDatepicker]="picker"
            />
            <mat-datepicker-toggle matSuffix [for]="picker">
                <mat-icon matDatepickerToggleIcon svgIcon="calendar"></mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error *ngIf="completedAt.invalid">{{ completedAt.errors | formErrors }}</mat-error>
        </mat-form-field>
        <mat-form-field *ngIf="record.trainingProgram.hasExpirationDate">
            <mat-label class="form-label">{{ 'forms.training.expirationDate' | appTranslate }}</mat-label>
            <input
                #expirationDate="ngModel"
                placeholder="YYYY-MM-DD"
                class="form-input"
                matInput
                name="expirationDate"
                [(ngModel)]="record.expirationDate"
                [matDatepicker]="picker"
            />
            <mat-datepicker-toggle matSuffix [for]="picker">
                <mat-icon matDatepickerToggleIcon svgIcon="calendar"></mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error *ngIf="expirationDate.invalid">{{ expirationDate.errors | formErrors }}</mat-error>
        </mat-form-field>
        <div class="form-grid">
            <mat-form-field *ngIf="record.trainingProgram.hasInstructor">
                <mat-label class="form-label">{{ 'forms.training.instructor' | appTranslate }}</mat-label>
                <input
                    type="text"
                    #instructor="ngModel"
                    name="instructor"
                    [(ngModel)]="record.instructor"
                    matInput
                    placeholder="{{ 'forms.training.egJohnSmith' | appTranslate }}"
                />
                <mat-error *ngIf="instructor.invalid">{{ instructor.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>
        <div class="form-grid">
            <mat-form-field *ngIf="record.trainingProgram.hasHours">
                <mat-label class="form-label">{{ 'forms.training.hours' | appTranslate }}</mat-label>
                <input #hours="ngModel" type="number" name="hours" [(ngModel)]="record.hours" matInput />
                <mat-error *ngIf="hours.invalid">{{ hours.errors | formErrors }}</mat-error>
            </mat-form-field>
            <mat-form-field *ngIf="record.trainingProgram.hasCredits">
                <mat-label class="form-label">{{ 'forms.training.credits' | appTranslate }}</mat-label>
                <input #credits="ngModel" type="number" name="credits" [(ngModel)]="record.credits" matInput />
                <mat-error *ngIf="credits.invalid">{{ credits.errors | formErrors }}</mat-error>
            </mat-form-field>
            <mat-form-field *ngIf="record.trainingProgram.hasCost">
                <mat-label class="form-label">{{ 'forms.training.cost' | appTranslate }}</mat-label>
                <input #cost="ngModel" name="cost" [(ngModel)]="record.cost" matInput />
                <mat-error *ngIf="cost.invalid">{{ cost.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>
        <mat-radio-group
            aria-label="Result"
            name="recordFormMatRadioGroup"
            [(ngModel)]="record.result"
            *ngIf="record.trainingProgram.hasResult"
        >
            <mat-label class="form-label">{{ 'forms.training.result' | appTranslate }}</mat-label>
            <mat-radio-button value="pass" class="form-input">{{
                'forms.training.pass' | appTranslate
            }}</mat-radio-button>
            <mat-radio-button value="fail" class="form-input">{{
                'forms.training.fail' | appTranslate
            }}</mat-radio-button>
        </mat-radio-group>
        <mat-form-field>
            <mat-label class="form-label">{{ 'forms.training.notes' | appTranslate }}</mat-label>
            <textarea matNativeControl name="notes" [(ngModel)]="record.notes" matInput></textarea>
        </mat-form-field>
        <app-file-uploader
            [allowedTypes]="['.pdf', '.png', '.jpg', '.jpeg']"
            [hasFiles]="record.trainingProgramRecordFiles"
            #fileUploader
        ></app-file-uploader>
    </ng-container>
</form>
